import React from 'react';
import { View } from 'react-native';

import PhoneSVG from '~/assets/svgs/phone.svg';
import colors from '~/assets/themes/colors';
import { Text } from '~/components';

interface Props {
  title: string;
  children: React.ReactNode;
}

const ContactCard: React.FC<Props> = ({ title, children }) => {
  return (
    <View className="bg-secondary-200 p-3 rounded-lg flex-row items-center mb-4 flex-1">
      <PhoneSVG color={colors.primary[600]} />

      <View className="flex-1 ml-6">
        <Text className="mb-2 text-sm text-gray-700">{title}</Text>
        {children}
      </View>
    </View>
  );
};

export default ContactCard;
